import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Tarea/Details/{id}',
  documento: 'crm',
  filas: ['141'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/TareaController.cs',
} satisfies RutaProd;
